import { ApiProblemError } from './apiFetchJson';

/**
 * True when a failed write may still have committed on the server, so the
 * caller should refetch what it just wrote (bd-ea20w saved-refresh rule): a
 * 2xx whose body failed its schema (`malformed`), or a request cut off before
 * the body was read (`aborted`). A real HTTP failure or a network error means
 * the write did not land, so nothing needs refreshing.
 */
export function writeMayHaveLanded(err: unknown): boolean {
  return err instanceof ApiProblemError && (err.kind === 'malformed' || err.kind === 'aborted');
}
